module.exports = {"description":"","displayName":"Required","methods":[],"props":{"text":{"type":{"name":"string"},"required":false,"description":"Text to show"},"isRequired":{"type":{"name":"bool"},"required":false,"description":"Show as required","defaultValue":{"value":"true","computed":false}},"cssMap":{"defaultValue":{"value":"require( './required.css' )","computed":true},"required":false}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/Required-props.json
// module id = 461
// module chunks = 0